import { useCallback } from 'react';
import { 
  logActivity, 
  ACTIVITY_TYPES, 
  createOrderActivity, 
  createClientActivity, 
  createEquipmentActivity, 
  createTechnicianActivity 
} from '../lib/activityService';
import { useAuth } from '../contexts/AuthContext';

/**
 * Hook for easily logging activities
 */
export const useActivity = () => {
  const { currentUser } = useAuth();

  const logOrderActivity = useCallback(async (action, orderFolio, additionalInfo = '', metadata = {}) => {
    try {
      let type;
      switch (action) {
        case 'created':
          type = ACTIVITY_TYPES.ORDER_CREATED;
          break;
        case 'updated':
          type = ACTIVITY_TYPES.ORDER_UPDATED;
          break;
        case 'status_changed':
          type = ACTIVITY_TYPES.ORDER_STATUS_CHANGED;
          break;
        default:
          type = ACTIVITY_TYPES.ORDER_UPDATED;
      }

      await logActivity(
        type,
        createOrderActivity(action, orderFolio, additionalInfo),
        metadata,
        currentUser?.uid
      );
    } catch (error) {
      console.error('Error logging order activity:', error);
    }
  }, [currentUser]);

  const logClientActivity = useCallback(async (action, clientName, additionalInfo = '', metadata = {}) => {
    try {
      const type = action === 'created' ? ACTIVITY_TYPES.CLIENT_CREATED : ACTIVITY_TYPES.CLIENT_UPDATED;
      
      await logActivity(
        type,
        createClientActivity(action, clientName, additionalInfo),
        metadata,
        currentUser?.uid
      );
    } catch (error) {
      console.error('Error logging client activity:', error);
    }
  }, [currentUser]);

  const logEquipmentActivity = useCallback(async (action, equipmentModel, additionalInfo = '', metadata = {}) => {
    try {
      const type = action === 'created' ? ACTIVITY_TYPES.EQUIPMENT_CREATED : ACTIVITY_TYPES.EQUIPMENT_UPDATED;
      
      await logActivity(
        type,
        createEquipmentActivity(action, equipmentModel, additionalInfo),
        metadata,
        currentUser?.uid
      );
    } catch (error) {
      console.error('Error logging equipment activity:', error);
    }
  }, [currentUser]);

  const logTechnicianActivity = useCallback(async (action, technicianName, additionalInfo = '', metadata = {}) => {
    try {
      const type = action === 'created' ? ACTIVITY_TYPES.TECHNICIAN_CREATED : ACTIVITY_TYPES.TECHNICIAN_UPDATED;
      
      await logActivity(
        type,
        createTechnicianActivity(action, technicianName, additionalInfo),
        metadata,
        currentUser?.uid
      );
    } catch (error) {
      console.error('Error logging technician activity:', error);
    }
  }, [currentUser]);

  return {
    logOrderActivity,
    logClientActivity,
    logEquipmentActivity,
    logTechnicianActivity
  };
};

export default useActivity;